/** @format */

export const SillyRangeValuesActionTypes = {
  SET_CURRENT_SILLYRANGEVALUES: 'SET_CURRENT_SILLYRANGEVALUES',
};
